import { useState, useEffect } from 'react';

const useDynamicLinks = (userId, organisationId, profileId) => {
    const [links, setLinks] = useState([]);
    const STORAGE_KEY = `dynamic-links-${userId}-${organisationId}-${profileId}`;

    useEffect(() => {
        const loadLinks = () => {
            if (userId && organisationId && profileId) {
                const storedLinks = localStorage.getItem(STORAGE_KEY);
                if (storedLinks) {
                    setLinks(JSON.parse(storedLinks));
                } else {
                    setLinks([]);
                }
            }
        };

        loadLinks();

        const handleStorageChange = (e) => {
            if (e.detail?.key === STORAGE_KEY) {
                loadLinks();
            }
        }

        window.addEventListener('dynamic-links-update', handleStorageChange);
        return () => window.removeEventListener('dynamic-links-update', handleStorageChange);

    }, [userId, organisationId, profileId, STORAGE_KEY]);

    const notifyChange = () => {
        window.dispatchEvent(new CustomEvent('dynamic-links-update', { detail: { key: STORAGE_KEY } }));
    }

    const saveLinks = (newLinks) => {
        setLinks(newLinks);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newLinks));
        notifyChange();
    };

    const addLink = (link) => {
        const newLinks = [...links, link];
        saveLinks(newLinks);
    };

    const updateLink = (path, newTitle) => {
        const newLinks = links.map((l) =>
            l.path === path ? { ...l, title: newTitle } : l
        );
        saveLinks(newLinks);
    };

    const removeLink = (path) => {
        const newLinks = links.filter((l) => l.path !== path);
        saveLinks(newLinks);
    };

    const getLink = (path) => {
        return links.find(l => l.path === path);
    }

    return { links, addLink, updateLink, removeLink, getLink };
};

export default useDynamicLinks;
